//REACT
import React, {useContext, useState} from 'react';
import {Link} from 'react-router-dom';

//MUI COMPONENTS
import {
    AppBar,
    Toolbar,
    IconButton,
    Box,
    Button,
    Typography,
    makeStyles,
    Container
} from '@material-ui/core';

//Custom Contexts
import {UserContext} from "../contexts/UserContext";
import logoImg from '../assets/neilsons_logo.svg';

const useStyles = makeStyles(theme => ({
    menuIcon: {
        marginRight: theme.spacing(2),
    },
    list:     {
        width: '200px',
    },
    link:     {
        textDecoration: 'none',
        color:'#757575'
    },
    linkTitle:     {
        paddingLeft: '30px',
        fontSize:'18px',
        textDecoration: 'none',
        color:'#FFFFFF',
        fontFamily: "Cabin",
        marginRight:30,
        [theme.breakpoints.down("sm")]: {
            fontSize:16,
            marginRight:10,
            paddingLeft: 10,
        },
        [theme.breakpoints.down("xs")]: {
            fontSize:14,
            marginRight:3,
            paddingLeft: 3,
        }

    },
    normalButton: {
        textTransform: 'none',
        fontSize:'18px',
        fontFamily:"Cabin",
        fontWeight:'bold',
        textDecoration:'underline',
        [theme.breakpoints.down("sm")]: {
            fontSize:16,
            marginRight:10,
            paddingLeft: 10,
        },
        [theme.breakpoints.down("xs")]: {
            fontSize:14,
            marginRight:5,
            paddingLeft: 5,
        }
    },
    bigNavBar:{
        paddingTop:'15px',
        paddingBottom:'15px',

    },
    tBar:{
        paddingLeft:0,
        paddingRight:0
    }
}));





const Navigation = () => {
    //styles
    const classes = useStyles();

    //state
    const [drawerOpen, setDrawerOpen] = useState(false);

    //functions
    const toggleDrawer = () => {
        setDrawerOpen(!drawerOpen);
    };

    const loginContext =  useContext(UserContext);


    const doLogOut = () =>{
        loginContext.doSignOut();
    };

    return (
        <AppBar className={classes.bigNavBar} position="fixed">
            <Container>
                <Toolbar className={classes.tBar}>
                    <img width="110" height="" src={logoImg} alt=""/>
                    <Link className={classes.linkTitle} to="/home">
                        <Typography  variant="h6">

                        </Typography>
                    </Link>
                    <Box flexGrow={1}/>
                    {
                        loginContext.amILoggedIn() ?
                            <>
                                {loginContext.client.length > 0 &&
                                    <>{loginContext.client[0].pc_first_name !== undefined ? <span
                                                className={classes.linkTitle}>Hello {loginContext.client[0].pc_first_name}</span> :
                                            <span> </span>
                                    }</>
                                }
                                <Button className={classes.normalButton} onClick={doLogOut} size="large" color="inherit">Sign Out</Button>
                            </> : ''

                    }
                </Toolbar>
            </Container>
        </AppBar>
    );
};

export default Navigation;